import { render } from "./QAQCOverviewShimmer.vue?vue&type=template&id=5e646720"
import script from "./QAQCOverviewShimmer.vue?vue&type=script&lang=js"
export * from "./QAQCOverviewShimmer.vue?vue&type=script&lang=js"

import "./QAQCOverviewShimmer.vue?vue&type=style&index=0&id=5e646720&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__